<template>
  <div class="w-100">
    <b-col class="px-50">
      <div class="dark-layout card d-flex flex-row px-2 py-1">
        <div style="z-index: 10">
          <b-img :src="require(`@/assets/images/new-images-fx/${imgTitle}`)">
          </b-img>
        </div>
        <div class="ml-1 d-flex align-items-center" style="z-index: 10">
          <h6 class="mb-0">{{ title }}</h6>
          <!-- <p class="mb-0">
            {{ SubTitle }}
          </p> -->
        </div>
        <div
          class="position-absolute top-0 left-0 w-100 h-100"
          style="border-radius: 12px"
          :class="
            type == 'REACH_TRADE'
              ? 'gradientTrade'
              : type == 'ENDED_COMPETITION'
              ? 'gradientEndC'
              : type == 'WIN_COMPETITION'
              ? 'gradientWinC'
              : type == 'PER_WIN_TRADE'
              ? 'gradientPerWinT'
              : type == 'JOIN_COMPETITION'
              ? 'gradientJoinC'
              : type == 'CHARGE'
              ? 'gradientCharg'
              : 'gradientTrade'
          "
        ></div>
      </div>
    </b-col>

    <div
      class="d-flex flex-wrap w-100 pt-1 justify-content-center"
      v-if="loading"
    >
      <b-col v-for="i in 4" :key="i" class="col-md col-6 py-md-1">
        <b-skeleton width="100%" height="250px" />
      </b-col>
    </div>

    <div
      class="d-flex flex-wrap justify-content-md-center align-items-center w-100 my-50 my-md-0"
      v-else
    >
      <b-col
        class="px-50 py-0 col-md col-6 pt-md-0 pb-md-0"
        v-for="(item, index) in value"
        :key="index"
      >
        <div
          class="card w-100 justify-content-center align-items-center p-2 mb-0"
          :class="
            index == 0 || index % 3 == 0
              ? 'scoreOne Active'
              : index % 2 == 0
              ? 'scoreThree Active'
              : index == 2
              ? 'scoreThree Active'
              : 'scoreFive Active'
          "
        >
          <div class="topBar">
            <!-- <p>You get {{ value[value.length - 1].value }} score.</p> -->
            <!-- <b-img
              :src="require('@/assets/images/new-images-fx/Mask Group 40.svg')"
              style="position: absolute; right: 0; top: 0"
            /> -->
          </div>
          <div style="" class="BoxImg card-img-to p-2 mt-4">
            <b-img
              :src="require(`@/assets/images/new-images-fx/${imgModal}`)"
              class="modalImg"
              alt=""
              width="50"
              height="50"
            />
          </div>
          <div class="card-body mt-1">
            <h3 class="card-text text-white">{{ item.value }}</h3>
          </div>
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BImg, BSkeleton } from "bootstrap-vue";
export default {
  components: {
    BRow,
    BCol,
    BImg,
    BSkeleton,
  },
  props: {
    title: {
      type: String,
    },
    type: {
      type: String,
    },
    SubTitle: {
      type: String,
      default: "Sub Title",
    },
    value: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    imgTitle: {
      type: String,
      default: "img-8.png",
    },
    imgModal: {
      type: String,
      default: "img-8.png",
    },
  },
};
</script>

<style lang="scss" scoped>
.gradient-competition {
  background: transparent
    linear-gradient(219deg, #26263300 0%, #21212c00 87%, #fa4b68 115%) 0% 0%
    no-repeat padding-box;
  border-radius: inherit;
}
.topBar {
  color: white;
  position: absolute;
  top: 0;
  width: 100%;
  height: 45px;
  padding: 10px 20px;
  border-radius: 12px 12px 0 0;
}
.BoxImg {
  background: transparent linear-gradient(160deg, #282833 0%, #15182508 100%);
  border-radius: 30px;
}

.gradientTrade {
  background: transparent
    linear-gradient(219deg, #21212100 0%, #31344800 49vw, #fbad25 112%) 0% 0%
    no-repeat padding-box;
}
.gradientCharg {
  background: transparent
    linear-gradient(219deg, #21212100 0%, #31344800 49vw, #fbad25 112%) 0% 0%
    no-repeat padding-box;
}
.gradientEndC {
  background: transparent
    linear-gradient(219deg, #21212100 0%, #31344800 49vw, #7a25fb 112%) 0% 0%
    no-repeat padding-box;
}
.gradientWinC {
  background: transparent
    linear-gradient(219deg, #21212100 0%, #31344800 49vw, #39a4f8 112%) 0% 0%
    no-repeat padding-box;
}
.gradientJoinC {
  background: transparent
    linear-gradient(219deg, #21212100 0%, #31344800 49vw, #39a4f8 112%) 0% 0%
    no-repeat padding-box;
}

.gradientPerWinT {
  background: transparent
    linear-gradient(219deg, #21212100 0%, #31344800 49vw, #fa4b68 112%) 0% 0%
    no-repeat padding-box;
}

.scoreOne {
  background: #14a29c;
  .topBar {
    background: #1bc1ba;
  }
  .BoxImg {
    background: transparent linear-gradient(160deg, #0fbeb6 27%, #1518254a 97%);
  }
}

.scoreTwo {
  background: #c1334a;
  .topBar {
    background: #fa4b68;
  }
  .BoxImg {
    background: transparent linear-gradient(160deg, #f63555 27%, #1518254a 97%);
  }
}
.scoreThree {
  background: #e2a334;
  .topBar {
    background: #fbad25;
  }
  .BoxImg {
    background: transparent linear-gradient(160deg, #fbad25 27%, #1518254a 97%);
  }
}

.scoreFour {
  background: #14a29c;
  .topBar {
    background: #1bc1ba;
  }
  .BoxImg {
    background: transparent linear-gradient(160deg, #0fbeb6 27%, #1518254a 97%);
  }
}

.scoreFive {
  background: #c1334a;
  .topBar {
    background: #fa4b68;
  }
  .BoxImg {
    background: transparent linear-gradient(160deg, #f63555 27%, #1518254a 97%);
  }
}
.modalImg {
  filter: grayscale(100%);
}
.Active {
  .modalImg {
    filter: grayscale(0%);
  }
}
</style>
